/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/

const lang = {
  /* 01.General */
  "general.copyright": "Gogo React © Todos los derechos reservados.",

  "unauthorized.title": "Unauthorized Access Attempt",
  "unauthorized.detail":
    "You are not authorized to view the page you are trying to access.",

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  "user.login-title": "Iniciar sesión",
  "user.register": "Registro",
  "user.forgot-password": "Se te olvidó tu contraseña",
  "user.email": "Email",
  "user.password": "Contraseña",
  "user.forgot-password-question": "¿Contraseña olvidada?",
  "user.fullname": "Nombre completo",
  "user.login-button": "INICIAR SESIÓN",
  "user.register-button": "REGISTRO",
  "user.reset-password-button": "REINICIAR",
  "user.buy": "COMPRAR",
  "user.username": "Nombre de Usuario",
  "user.reset-password": "Reset Password",
  "user.new-password": "New Password",
  "user.new-password-again": "Confirm New Password",

  /* 03.Menú */
  "menu.home": "Inicio",
  "menu.app": "Inicio",
  "menu.dashboards": "Tableros",
  "menu.gogo": "Gogo",
  "menu.start": "Comienzo",
  "menu.projects": "Projects",
  "menu.reports": "Reports",
  "menu.second-menu": "Segundo menú",
  "menu.second": "Segundo",
  "menu.ui": "IU",
  "menu.charts": "Gráficos",
  "menu.chat": "Chatea",
  "menu.survey": "Encuesta",
  "menu.todo": "Notas",
  "menu.search": "Búsqueda",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",
  /* 04.Error  */
  "layouts.error-title": "Vaya, parece que ha ocurrido un error!",
  "layouts.error-code": "Código de error",
  "layouts.go-back-home": "REGRESAR A INICIO",
  "pages.purchase": "PURCHASE",

  // 05. Project List Page
  "projects-list.title": "Project List",
  "projects-list.add-project-title": "Add New Project",
  "pages.prices.featurecomparison": "Feature Comparison",

  // 06. Add New Project Modal
  "add-project-modal.title": "Create New Project",
  "add-project-modal.project-type-label": "Select Project Type",
  "add-project-modal.project-name-label": "Project Name",

  // 07. Button common labels
  "button.create": "Create",
  "button.save": "Save",
  "button.cancel": "Cancel",
  "button.edit": "Edit",
  "button.delete": "Delete",
  "button.publish": "Publish",
  "button.unpublish": "Unpublish",
  "button.preview": "Preview",
  "button.upload-media": "Upload Media",
  "button.confirm": "Confirm",
  "button.select-media": "Select Media",
  "button.remove": "Remove",
  "button.connect-domain": "Connect Domain",
  "button.disconnect-domain": "Disconnect Domain",

  // 08. AR Card
  "ar-card.title": "AR Card Details",
  "ar-card.add-title": "Add AR Card Details",
  "ar-card.edit-title": "Edit AR Card Details",
  "ar-card.full-name-label": "Full Name",
  "ar-card.email-label": "Email",
  "ar-card.phone-label": "Phone Number",
  "ar-card.website-label": "Website URL",
  "ar-card.image-label": "Image Link",
  "ar-card.image-file-label": "Image File",
  "ar-card.video-label": "Video Link",
  "ar-card.video-file-label": "Video File",
  "ar-card.instagram-label": "Instagram",
  "ar-card.twitter-label": "Twitter",
  "ar-card.linkedIn-label": "LinkedIn",

  // 09. Product Visualization
  "pv.title": "Product Visualization Details",
  "pv.add-title": "Add Product Visualization Details",
  "pv.edit-title": "Edit Product Visualization Details",
  "pv.3d-model-label": "3D Model",
  "pv.usdz-model-label": "USDZ Model",
  "pv.skyBox-bg-image-label": "SkyBox Bg Image",
  "pv.poster-label": "Poster",
  "pv.ar-placement-label": "AR Placement",
  "pv.auto-rotate-label": "Auto Rotate",

  // 10. Project Types
  "project.ar-card": "AR Card",
  "project.product-visualizer": "Product Visualizer",
};

export default lang;
